import { withTranslation } from 'react-i18next'
import Profile from './Profile'

export default withTranslation()(Profile)
